import { createApp } from "vue";
import App from "./App.vue"; // root
import router from "./router"; // router

const app = createApp(App).use(router);

// import VConsole from "vconsole";
// const vConsole = new VConsole();

// vant
import "vant/lib/index.css";

// util
import util from "./assets/util";
app.config.globalProperties.util = util;

// i18n
import { createI18n } from "vue-i18n";
const messages = {
    zh: {
        // 页面分享
        让世界上每一个有可能的地方都变成家:
            "让世界上每一个有可能的地方都变成家！",
        Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢:
            "Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢！",
        // 评论
        评论: "评论",
        发表你的天才演讲: "发表你的天才演讲",
        作者: "作者",
        回复: "回复",
        加载中: "加载中...",
        // lifestyle列表
        城市: "城市",
        推荐: "推荐",
        不限: "不限",
        // 个人中心
        TA的房源: "TA的房源",
        TA的唯心市集: "TA的唯心市集",
        TA的Lifestyle: "TA的Lifestyle",
        TA的动态: "TA的动态",
        查看更多: "查看更多",
        私信: "私信",
        // 房源列表
        位置: "位置",
        租房类型: "租房类型",
        价格: "价格",
        区域: "区域",
        地铁: "地铁",
        租期: "租期",
        确定: "确定",
        最后登录: "最后登录",
        全部: "全部",
        // 房源详情
        详情: "详情",
        概况: "概况",
        已出租: "已出租",
        租金: "租金",
        月: "月",
        类型: "类型",
        房间: "房间",
        卧室: "卧室",
        洗手间: "洗手间",
        押金: "押金",
        面积: "面积",
        楼层: "楼层",
        描述: "描述",
        设施: "设施",
        地图: "地图",
        线上签约: "线上签约",
        // 首页
        搜索房源: "搜索房源",
        即将开放: "即将开放",
        唯心市集: "唯心市集",
        发现更多: "发现更多",
        探索: "探索",
        体验: "体验",
        打开APP: "打开APP",
        选择城市: "选择城市",
        // 下载页
        一个有灵魂的租房平台: "一个有灵魂的租房平台",
        无中介国际化社交: "无中介｜国际化｜社交",
        立即打开: "立即打开",
        立即下载: "立即下载",

        // 商务合作
        商务合作: "商务合作",
        请选择: "请选择",
        合作类型: "合作类型",
        姓名: "姓名",
        你的称呼: "你的称呼",
        联系方式: "联系方式",
        手机号微信号: "手机号/微信号",
        公司名称: "公司",
        请输入: "请输入",
        希望开展合作的城市: "希望开展合作的城市",
        备注: "备注",
        选填: "（选填）",
        提交: "提交",
        公寓商户: "公寓商户",
        优质民宿: "优质民宿",
        异业合作: "异业合作",
        广告推广: "广告推广",
        其他: "其他",
        公寓商户介绍: "包含公寓、二房东、包租公司、城中村大业主等",
        提交成功: "提交成功",
        请填写完整信息: "请填写完整信息",

        // 收不到验证码
        'no_auth_code.title': "收不到验证码",
        'no_auth_code.header': "如果您的手机无法正常获取验证码，建议您进行以下操作：",
        'no_auth_code.step1': "检查并确认您的手机号是否停机/无网络。",
        'no_auth_code.step2': "检查您的验证码是否被拦截/移至垃圾箱。",
        'no_auth_code.step3': "如进行以上操作后仍无法收到验证码，请发邮件联系我们：",
        'no_auth_code.step4': " 并附加您的个人信息。",
        'no_auth_code.card.title': "示例：",
        'no_auth_code.card.item1': "标题：手机号无法收取验证码",
        'no_auth_code.card.item2': "账户昵称：Max",
        'no_auth_code.card.item3': "手机号：+86 130****3465（添加您的国家区号）",
        'no_auth_code.card.item4': '邮箱：',
        'no_auth_code.card.item5': "性别：女",
        'no_auth_code.footer': "收到您的邮件后，我们会协助您处理账号相关问题。",

        // 手机号停机
        'phone_stop.title': "手机号停机",
        'phone_stop.header': "如果您的手机号已停机，无法登录账号，请通过邮箱联系我们并附加个人信息：",
        'phone_stop.card.title': "示例：",
        'phone_stop.card.item1': "标题：手机号停机无法登录",
        'phone_stop.card.item2': "账号昵称：Maxim",
        'phone_stop.card.item3': "账号绑定手机号：+86 130****3465",
        'phone_stop.card.item4': "新手机号：+86 183****1098",
        'phone_stop.card.item5': "城市：北京",
        'phone_stop.footer': "收到您的邮件后，我们会协助您找回账号。",

        // 优惠券规则
        'coupon_rule.title': '优惠券通用规则',
    },
    en: {
        // 页面分享
        让世界上每一个有可能的地方都变成家:
            "Create new ways of living and sharin life!",
        Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢:
            "Our Wellcee friends shared so many nice moments and stories with you!",
        // 评论
        评论: "Comment",
        发表你的天才演讲: "Leave your genius comment here",
        作者: "Author",
        回复: "Reply",
        加载中: "Loading...",
        // lifestyle列表
        城市: "City",
        推荐: "Hot",
        不限: "Default",
        TA的房源: "Housing",
        TA的唯心市集: "Swap&Sale",
        TA的Lifestyle: "Lifestyle",
        TA的动态: "Dynamic",
        查看更多: "More",
        // 房源列表
        位置: "Location",
        租房类型: "Rent type",
        价格: "Price",
        区域: "District",
        租期: "Term",
        确定: "Confirm",
        最后登录: "Last login",
        全部: "All",
        // 房源详情
        详情: "Details",
        概况: "Overview",
        已出租: "Rented",
        租金: "Rent",
        月: "Month",
        类型: "Type",
        房间: "Room",
        卧室: "Bedroom",
        洗手间: "Bathroom",
        地铁: "Metro",
        押金: "Deposit",
        面积: "Room size",
        楼层: "Floor",
        描述: "Description",
        设施: "Facilities",
        地图: "Map",
        线上签约: "Apply",
        私信: "Chat",
        // 首页
        搜索房源: "Search Apt",
        即将开放: "Coming soon",
        唯心市集: "Swap&Sale",
        发现更多: "More",
        探索: "Discover",
        体验: "Explore",
        打开APP: "Open the APP",
        选择城市: "Select city",
        // 下载页
        一个有灵魂的租房平台: "A renting App with soul",
        无中介国际化社交: "direct rental｜international｜social",
        立即打开: "Open Immediately",
        立即下载: "Download Now",
        // 商务合作
        商务合作: "Business Cooperation",
        请选择: "Choose",
        合作类型: "Cooperation Type",
        姓名: "Name",
        你的称呼: "How would you like us to call you",
        联系方式: "Contact Number",
        手机号微信号: "Tel Number/Wechat",
        公司名称: "Company",
        请输入: "Please Enter Here",
        希望开展合作的城市: "Preferred Cities for Collaboration",
        备注: "Other",
        选填: "(Optional)",
        提交: "Submit",
        公寓商户: "Residence",
        优质民宿: "B&B",
        异业合作: "Co-branding",
        广告推广: "Ads Promotion",
        其他: "Other",
        公寓商户介绍: "Including service apts, residences, hotels, etc.",
        提交成功: "Submitted",
        请填写完整信息: "Please fill in all the required information",

        // 收不到验证码
        'no_auth_code.title': "Verification Code Problem",
        'no_auth_code.header': "If you cannot receive the verification code, please try the following actions:",
        'no_auth_code.step1': "Check and confirm if your phone number is deactivated or has no network.",
        'no_auth_code.step2': "Check if the verification code is being intercepted or moved to spam.",
        'no_auth_code.step3': "If you still cannot receive the code after these steps, please email us to ",
        'no_auth_code.step4': " with your personal information.",
        'no_auth_code.card.title': "Example:",
        'no_auth_code.card.item1': "Title: Unable to Receive Verification Code",
        'no_auth_code.card.item2': "Username: Max",
        'no_auth_code.card.item3': "Phone: +86 130****3465 (Add your country code)",
        'no_auth_code.card.item4': "Email: ",
        'no_auth_code.card.item5': "Gender: Female",
        'no_auth_code.footer': "After receiving your email, we will assist you in handling account-related issues.",

        // 手机号停机
        'phone_stop.title': "Number Deactivated",
        'phone_stop.header': "If your number is deactivated and you can't log in, please email us with your personal information at ",
        'phone_stop.card.title': "Example:",
        'phone_stop.card.item1': "Title: Unable to Log In – Phone Number Deactivated",
        'phone_stop.card.item2': "Username: Max",
        'phone_stop.card.item3': "Deactivated Number: +86 130****3465",
        'phone_stop.card.item4': "New Number: +86 183****1098",
        'phone_stop.card.item5': "City: Beijing",
        'phone_stop.footer': "After receiving your email, we will assist you in recovering your account.",

        // 优惠券规则
        'coupon_rule.title': 'Coupon Rules',
    },
    tw: {
        // 页面分享
        让世界上每一个有可能的地方都变成家:
            "讓世界上每一個有可能的地方都變成家！",
        Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢:
            "Wellcee的小伙伴們分享了好多有趣的故事和瞬間呢！",
        // 评论
        评论: "評論",
        发表你的天才演讲: "發表你的天才演講",
        作者: "作者",
        回复: "回複",
        加载中: "加載中...",
        推荐: "推薦",
        不限: "不限",
        TA的房源: "TA的房源",
        TA的唯心市集: "TA的唯心市集",
        TA的Lifestyle: "TA的Lifestyle",
        TA的动态: "TA的動態",
        查看更多: "查看更多",
        // 房源列表
        位置: "位置",
        租房类型: "租房類型",
        价格: "價格",
        区域: "區域",
        租期: "租期",
        确定: "確定",
        最后登录: "最後登錄",
        全部: "全部",
        // 房源详情
        详情: "詳情",
        概况: "概況",
        已出租: "已出租",
        租金: "租金",
        月: "月",
        类型: "類型",
        房间: "房間",
        卧室: "臥室",
        洗手间: "洗手間",
        地铁: "地鐵",
        押金: "押金",
        面积: "面積",
        楼层: "樓層",
        描述: "描述",
        设施: "設施",
        地图: "地圖",
        线上签约: "線上簽約",
        私信: "私信",
        // 首页
        搜索房源: "搜索房源",
        即将开放: "即將開放",
        唯心市集: "唯心市集",
        发现更多: "發現更多",
        探索: "探索",
        体验: "體驗",
        打开APP: "打開APP",
        选择城市: "選擇城市",
        // 下载页
        一个有灵魂的租房平台: "一個有靈魂的租房平台",
        无中介国际化社交: "無中介｜國際化｜社交",
        立即打开: "立即打開",
        立即下载: "立即下載",

        // 商务合作
        商务合作: "商務合作",
        请选择: "請選擇",
        合作类型: "合作類型",
        姓名: "姓名",
        你的称呼: "你的稱呼",
        联系方式: "聯絡方式",
        手机号微信号: "手機號碼/微信號",
        公司名称: "公司",
        请输入: "請輸入",
        城市: "城市",
        希望开展合作的城市: "希望開展合作的城市",
        备注: "其他",
        选填: "（選填）",
        提交: "提交",
        公寓商户: "公寓商戶",
        优质民宿: "優質民宿",
        异业合作: "異業合作",
        广告推广: "廣告推廣",
        其他: "其他",
        公寓商户介绍: "包含公寓、二房東、包租公司、城中村大業主等",
        提交成功: "提交成功",
        请填写完整信息: "請填寫完整信息",

        // 收不到验证码
        'no_auth_code.title': "收不到驗證碼",
        'no_auth_code.header': "如果您的手機無法正常獲取驗證碼，建議您進行以下操作：",
        'no_auth_code.step1': "檢查並確認您的手機號是否停機/無網絡。",
        'no_auth_code.step2': "檢查您的驗證碼是否被攔截/移至垃圾箱。",
        'no_auth_code.step3': "如進行以上操作後仍無法收到驗證碼，請發郵件聯繫我們：",
        'no_auth_code.step4': " 並附上您的個人信息。",
        'no_auth_code.card.title': "示例：",
        'no_auth_code.card.item1': "標題: 手機號無法接收驗證碼",
        'no_auth_code.card.item2': "帳戶暱稱: Max",
        'no_auth_code.card.item3': "手機號: +86 130****3465（添加您的國家區號）",
        'no_auth_code.card.item4': "郵箱: ",
        'no_auth_code.card.item5': "性別: 女",
        'no_auth_code.footer': "收到您的郵件後，我們會協助您處理帳號相關問題。",

        // 手机号停机
        'phone_stop.title': "手機號停機",
        'phone_stop.header': "如果您的手機號已停機，無法登錄賬號，請通過郵箱聯繫我們並附上個人信息：",
        'phone_stop.card.title': "示例：",
        'phone_stop.card.item1': "標題: 手機號停機無法登錄",
        'phone_stop.card.item2': "帳戶暱稱: Max",
        'phone_stop.card.item3': "帳戶綁定的手機號: +86 130****3465",
        'phone_stop.card.item4': "新手機號: +86 183****1098",
        'phone_stop.card.item5': "城市: 北京",
        'phone_stop.footer': "收到您的郵件後，我們會協助您找回賬號。",

        // 优惠券规则
        'coupon_rule.title': '優惠券通用規則',
    },
};
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: util.language("text") || "zh", // set locale
    fallbackLocale: ["en", "tw"], // set fallback locale
    messages: messages, // set locale messages
});
app.use(i18n);

// download plugin
import download from "./assets/download";
app.use(download);

app.mount("#app");
